<template>
  <div>
    <el-collapse v-model="activeNames" >
      <MyCollapse iconPath="/static/de-zmr.png" title="救助申请审核记录" name="1">
        <el-table :data="helpData">
          <el-table-column prop="apprNodeText" label="节点名称"> </el-table-column>
          <el-table-column prop="apprStatusText" label="流程状态">
            <template v-slot="scope">
              {{ scope.row.apprStatus == 5 ? '审核中' : scope.row.apprStatusText }}
            </template>
          </el-table-column>
          <el-table-column prop="apprUserText" label="经办人"> </el-table-column>
          <el-table-column prop="apprTime" label="处理时间">
            <template v-slot="scope">
              {{ scope.row.apprTime | convertTime("YYYY-MM-DD HH:mm") }}
            </template>
          </el-table-column>
          <el-table-column prop="apprOpinion" label="意见说明"> </el-table-column>
        </el-table>
      </MyCollapse>
    </el-collapse>
  </div>
</template>

<script>
import {
  getJzshDataListByCondNoPaging,
} from "@/util/api";
import ChapterHead from "@/components/business/ChapterHead";
import OutlayHistory from '@/pages/outlay/view/OutlayHistory';
import ProtocolHistory from '@/pages/protocol/view/ProtocolHistory';
import MyCollapse from '@/components/business/MyCollapse'
export default {
  components: {
    ChapterHead,
    OutlayHistory,
    ProtocolHistory,
    MyCollapse
  },
  props: ['helpId', 'outlayId', 'protocolId'],
  data () {
    return {
      helpData: [],
      outlayData: [],
      activeNames:['1','2','3'],
      protocolData: []
    }
  },
  mounted () {
    this.loadHelpData();
  },
  methods: {
    loadHelpData () {
      if (this.helpId) {
        getJzshDataListByCondNoPaging({
          searchCond: {
            helpId: this.helpId,
            forApprOnly: 1
          },
          orderBy:'apprTime'
        }).then(res => {
          if (res.msgCode == 200) {
            this.helpData = res.responseData.modelData;
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/child/view/ChildHistory.vue